import React from 'react';
import { Box, Typography } from '@mui/material';

import { convertTimestampToDateDayMonthYear } from '../../utils/TimestampConvert';
import { formatNumberToEuroString } from '../../utils/FormatToPrice';

const HistoryCard = ({ timestamp, sum, operationType }) => {

    const date = convertTimestampToDateDayMonthYear(timestamp)

    const sumReformat = formatNumberToEuroString(sum)

    return (
        <Box
            sx={{
                border: 1,
                borderRadius: 1,
                width: '100%',
                marginY: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: 2,
                bgcolor: operationType === 'add' ? 'white' : 'black'
            }}
        >
            <Typography color={operationType === 'add' ? 'primary' : 'secondary'}>
                {date}
            </Typography>

            <Typography
                sx={{
                    minWidth: 50,
                    textAlign: 'left'
                }}
                color={operationType === 'add' ? 'primary' : 'secondary'}
            >

                {operationType === 'add' ? '+' : '-'}
                {' '}
                {sumReformat} €
            </Typography>
        </Box>
    )
}

export default HistoryCard;